var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DCubeScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 6.00001V4.66668C1.33325 2.66668 2.66659 1.33334 4.66659 1.33334H11.3333C13.3333 1.33334 14.6666 2.66668 14.6666 4.66668V6.00001",
    stroke: "#808897",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 10V11.3333C1.33325 13.3333 2.66659 14.6667 4.66659 14.6667H11.3333C13.3333 14.6667 14.6666 13.3333 14.6666 11.3333V10",
    stroke: "#808897",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46655 6.17334L7.99989 8.22001L11.5066 6.18669",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8467V8.21335",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17324 4.19332L5.03991 5.38001C4.55991 5.64667 4.15991 6.32 4.15991 6.87333V9.13334C4.15991 9.68668 4.55324 10.36 5.03991 10.6267L7.17324 11.8133C7.62657 12.0666 8.37324 12.0666 8.83324 11.8133L10.9666 10.6267C11.4466 10.36 11.8466 9.68668 11.8466 9.13334V6.87333C11.8466 6.32 11.4532 5.64667 10.9666 5.38001L8.83324 4.19332C8.37324 3.93332 7.62657 3.93332 7.17324 4.19332Z",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DCubeScan);
export default __webpack_public_path__ + "static/media/3d-cube-scan.cb3f1afce55cb57f6fb978ec6f0a7bd6.svg";
export { ForwardRef as ReactComponent };